
import { defineComponent } from "vue";

import Loader from "@/components/Loader.vue";
import CheckBox from "@/components/Checkbox.vue";
import { State } from "@/store";
import { mapState } from "vuex";

const phoneRegex = /^\+?[0-9\s]+$/;

enum FieldNames {
    firstName = "firstName",
    lastName = "lastName",
    email = "email",
    phone = "phone",
    videoAgreement = "videoAgreement"
}

export default defineComponent({
    name: "PersonalDataForm",
    components: {
        Loader,
        CheckBox
    },
    data() {
        return {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            videoAgreement: false,
            consentChecked: false,
            isPending: false,
            errors: {} as { [key: string]: string }
        };
    },
    computed: {
        formInvalid() {
            return Object.keys(FieldNames).find(
                fieldName => fieldName !== "videoAgreement" && this.checkField(fieldName).length > 0
            );
        },
        ...mapState({
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject
        }),
        firstNameLabel() {
            let label = this.$t("personalDataForm.firstNameLabel");

            if (this.qrcodeObject?.getUserFirstName === "required") {
                label += "*";
            }

            return label;
        },
        lastNameLabel() {
            let label = this.$t("personalDataForm.lastNameLabel");

            if (this.qrcodeObject?.getUserLastName === "required") {
                label += "*";
            }

            return label;
        },
        emailLabel() {
            let label = this.$t("personalDataForm.emailLabel");
            
            if (this.qrcodeObject?.getUserEmail === "required") {
                label += "*";
            }

            return label;
        },
        phoneLabel() {
            let label = this.$t("personalDataForm.phoneLabel");

            if (this.qrcodeObject?.getUserPhone === "required") {
                label += "*";
            }

            return label;
        },
        videoAgreementText() {
            let text = this.qrcodeObject.videoAgreementMsg;

            if (this.qrcodeObject?.getVideoAgreement === "required") {
                text += "*";
            }

            return text;
        }
    },
    methods: {
        async submitForm() {
            const videoAgreementField = this.checkField(FieldNames.videoAgreement);

            if (videoAgreementField) {
                this.errors[FieldNames.videoAgreement] = videoAgreementField;
                return;
            }

            this.$store.dispatch("record/setUserData", {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: this.phone,
                videoAgreement: this.videoAgreement
            });
            this.$router.push("Upload");
        },
        clearFieldError(fieldName: string) {
            delete this.errors[fieldName];
        },
        toggleAgreement(value: boolean) {
            this.videoAgreement = value;
            this.clearFieldError(FieldNames.videoAgreement);
        },
        checkField(fieldName: string) {
            let result = "";
            switch (fieldName) {
                case FieldNames.firstName:
                    if (
                        this.qrcodeObject?.getUserFirstName === "required" &&
                        !this.firstName.length
                    ) {
                        result = "fieldRequired";
                    }
                    break;

                case FieldNames.lastName:
                    if (this.qrcodeObject.getUserLastName === "required" && !this.lastName.length) {
                        result = "fieldRequired";
                    }
                    break;

                case FieldNames.email:
                    if (this.qrcodeObject.getUserEmail === "required" && !this.email.length) {
                        result = "fieldRequired";
                    }
                    break;

                case FieldNames.videoAgreement:
                    if (
                        this.qrcodeObject?.getVideoAgreement === "required" &&
                        !this.videoAgreement
                    ) {
                        result = "videoAgreement";
                    }
                    break;

                case FieldNames.phone:
                    if (this.qrcodeObject.getUserPhone === "required" && !this.phone.length) {
                        result = "fieldRequired";
                    } else if (
                        this.qrcodeObject.getUserPhone !== "no" &&
                        this.phone.length &&
                        !phoneRegex.test(this.phone)
                    ) {
                        result = "fieldValueIncorrect";
                    }
                    break;
            }

            return result;
        },
        onFieldBlur(fieldName: string) {
            const errors = this.checkField(fieldName);
            this.errors[fieldName] = errors;
        },
        onEmailInput(ev: Event) {
            const input = ev.target as HTMLInputElement;
            input.value = input.value.toLowerCase();
        }
    }
});
